// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import navigationStructure from '../NavigationStructure';
import FAQ from './FAQ.js';
import NavigationButton from './NavigationButton';

import type { AppStateType } from '../Types.js';

import "../css/NavigationButtons.css";

type Props = {
  location: Object,
  appState: AppStateType
};

class NavigationButtons extends Component<Props> {
  showPreviousButton() {
    return navigationStructure[this.props.location.pathname].showButtons ||
      navigationStructure[this.props.location.pathname].showPrevious;
  }

  showNextButton() {
    return navigationStructure[this.props.location.pathname].showButtons ||
      navigationStructure[this.props.location.pathname].showNext;
  }

  showFAQ(){
    return navigationStructure[this.props.location.pathname].FAQ || false;
  }

  participantHasResultsInGroup(group) {
    const group_name = this.props.intl.messages[`chemicals.${group}.data`];
    if(this.props.appState.groups !== undefined && this.props.appState.groups[group_name] !== undefined) {
      return this.props.appState.groups[group_name].filter((d) => d.mine === true).length > 0;
    }
    else
      return false;
  }

  previousPage() {
    const keys = Object.keys(navigationStructure);
    const index = keys.indexOf(this.props.location.pathname);
    return this._previousPage(index);
  }

  _previousPage(index) {
    const keys = Object.keys(navigationStructure);
    // if(navigationStructure[keys[index - 1]].group !== undefined) {
    //   if(this.participantHasResultsInGroup(navigationStructure[keys[index - 1]].group)) {
    //     return keys[index - 1];
    //   }
    //   else {
    //     return this._previousPage(index - 1);
    //   }
    // }
    // else if(keys[index - 1] === '/water_summary') {
    //   if(!this.participantHasResultsInGroup('water_cvocs') && !this.participantHasResultsInGroup('water_phthalates')) {
    //     return this._previousPage(index - 1);
    //   }
    // }

    // skip the poe if not in the study group that gets it
    if (keys[index - 1] == "/readinggraphs") {
      if (!this.props.appState.showPOE) {
        return keys[index - 2]
      }
    }

    // from the community action, the previous button does to summary
    if (this.props.location.pathname.includes("/community_action")) {
      return "/summary";
    }

    return keys[index - 1];
  }

  nextPage() {
    // the next button on the tour page behaves differently
    if (this.props.location.pathname == "/readinggraphs") {
      return "/readinggraphs#tour"
    }

    const keys = Object.keys(navigationStructure);
    const index = keys.indexOf(this.props.location.pathname);
    return this._nextPage(index);
  }

  _nextPage(index) {
    const keys = Object.keys(navigationStructure);

    // from the chemical page, the "next" button goes back to the summary
    if (this.props.location.pathname.includes("/chemicals/")) {
      return "/summary";
    }

    // from the personal results summary page, the "next" button goes back to the community action
    if (this.props.location.pathname.includes("/summary")) {
      return "/community_action";
    }

    // if(navigationStructure[keys[index + 1]].group !== undefined) {
    //   if(this.participantHasResultsInGroup(navigationStructure[keys[index + 1]].group)) {
    //     return keys[index + 1];
    //   }
    //   else {
    //     return this._nextPage(index + 1);
    //   }
    // }
    // else if(keys[index + 1] === '/water_summary') {
    //   // check if the participant has any water results
    //   if(!this.participantHasResultsInGroup('water_cvocs') && !this.participantHasResultsInGroup('water_phthalates')) {
    //     return '/community_action';
    //   }
    // }

    // skip the poe if not in the study group that gets it
    if (keys[index + 1] == "/readinggraphs") {
      if (!this.props.appState.showPOE) {
        return keys[index + 2]
      }
    }

    return keys[index + 1];
  }



  render() {
    // console.log(this.props);
    // let chemicalPage = false;
    // if (this.props.location.pathname.includes("/chemicals/")) {chemicalPage = true}
    let page = ""
    if (this.props.location.pathname.includes("/about")) {page = "about"}
    if (this.props.location.pathname.includes("/summary")) {page = "summaryResultsPage"}
    if (this.props.location.pathname.includes("/chemicals/")) {page = "chemicalsPage"}

    let previous = this.showPreviousButton() ? (
      <NavigationButton to={this.previousPage()} side="left" lowPriority={true} messageId='previous' />
    ) : null;

    let nextMessageID = "next"
    if (this.props.location.pathname.includes("/summary")) {nextMessageID = 'more_ways_to_help'}
    if (this.props.location.pathname.includes("/chemicals/")) {nextMessageID = "back_to_summary"}
    let next = this.showNextButton() ? (
      <NavigationButton to={this.nextPage()} side='right' messageId={nextMessageID} page={page}/>
    ) : null;

    let numFAQs = this.props.intl.messages[`common_questions.number_questions`];
    const faq = this.showFAQ() ? (
        <FAQ numFAQs={numFAQs}></FAQ>
    ) : null;

    let backToSummary;
    // if (chemicalPage) {
    //   backToSummary = <NavigationButton to="/summary" side="left" lowPriority={true} messageId='back_to_summary' currentPage={this.props.location.pathname}/>
    // }


    return (previous != null || next != null) ? (
      <div className='buttons'>
        {backToSummary}
        {next}
        {previous}
        {faq}
      </div>
    ) : null;
  }
};

export default injectIntl(withRouter(observer(NavigationButtons)));



// WEBPACK FOOTER //
// ./src/components/NavigationButtons.js